import React from 'react';
import { useSelector } from 'react-redux';
import Logo from '../../assest/logo.png';
import {
  FaFacebookF,
  FaXTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaArrowRight
} from "react-icons/fa6";
// import { FaFacebookF, FaXTwitter, FaYoutube, FaLinkedinIn } from 'react-icons/fa6';


const Footer = () => {
  const { language } = useSelector((state) => state.language);

  const socialLinks = [
    { icon: FaFacebookF, url: 'https://www.facebook.com/YourPage' },
    { icon: FaXTwitter, url: 'https://twitter.com/YourProfile' },
    { icon: FaYoutube, url: 'https://www.youtube.com/YourChannel' },
    { icon: FaLinkedinIn, url: 'https://www.linkedin.com/company/etihad-gharbia-contracting-co/?viewAsMember=true' }
  ];

  // Translation dictionary
  const translations = {
    en: {
      companyName: "Etihad Gharbia",
      companyDescription: "Leading provider of contracting, manpower supply, equipment rental & transport solutions since 2010.",
      ourServices: "Our Services",
      services: [
        ['Contracting', '/services/contracting'],
        ['Equipment Rental', '/services/equipment-rental'],
        ['Manpower Supply', '/services/manpower'],
        ['Transportation', '/services/transportation'],
        ['IT & GPS Solutions', '/services/it-gps'],
        ['Construction', '/services/construction'],
      ],
      usefulLinks: "Useful Links",
      links: [
        ['About Us', '/about'],
        ['Careers', '/careers'],
        ['FAQ', '/faq'],
        ['News & Media', '/news'],
        ['Contact Us', '/contact'],
      ],
      stayUpdated: "Stay Updated",
      newsletterText: "Subscribe to our newsletter for updates on projects, insights, and offers.",
      emailPlaceholder: "Your email",
      subscribe: "Subscribe",
      contact: {
        phone: "Phone:",
        website: "Website:",
        clients: "Clients:"
      },
      copyright: "© 2025 Etihad Gharbia Contracting Company. All rights reserved.",
      terms: "Terms of Use",
      privacy: "Privacy Policy"
    },
    sa: {
      companyName: "اتحاد غربيا",
      companyDescription: "الرائد في تقديم حلول المقاولات وتوريد العمالة وتأجير المعدات والنقل منذ عام 2010.",
      ourServices: "خدماتنا",
      services: [
        ['المقاولات', '/services/contracting'],
        ['تأجير المعدات', '/services/equipment-rental'],
        ['توريد العمالة', '/services/manpower'],
        ['النقل', '/services/transportation'],
        ['حلول تكنولوجيا المعلومات والGPS', '/services/it-gps'],
        ['البناء', '/services/construction'],
      ],
      usefulLinks: "روابط مفيدة",
      links: [
        ['معلومات عنا', '/about'],
        ['وظائف', '/careers'],
        ['الأسئلة الشائعة', '/faq'],
        ['الأخبار والإعلام', '/news'],
        ['اتصل بنا', '/contact'],
      ],
      stayUpdated: "ابق على اطلاع",
      newsletterText: "اشترك في نشرتنا الإخبارية للحصول على تحديثات المشاريع والرؤى والعروض.",
      emailPlaceholder: "بريدك الإلكتروني",
      subscribe: "اشتراك",
      contact: {
        phone: "هاتف:",
        website: "موقع الكتروني:",
        clients: "العملاء:"
      },
      copyright: "© 2025 شركة اتحاد غربيا للمقاولات. جميع الحقوق محفوظة.",
      terms: "شروط الاستخدام",
      privacy: "سياسة الخصوصية"
    },
    fr: {
      companyName: "Etihad Gharbia",
      companyDescription: "Principal fournisseur de solutions de contrat, de main-d'œuvre, de location d'équipement et de transport depuis 2010.",
      ourServices: "Nos Services",
      services: [
        ['Contrat', '/services/contracting'],
        ['Location d\'équipement', '/services/equipment-rental'],
        ['Fourniture de main-d\'œuvre', '/services/manpower'],
        ['Transport', '/services/transportation'],
        ['Solutions IT & GPS', '/services/it-gps'],
        ['Construction', '/services/construction'],
      ],
      usefulLinks: "Liens Utiles",
      links: [
        ['À propos', '/about'],
        ['Carrières', '/careers'],
        ['FAQ', '/faq'],
        ['Actualités', '/news'],
        ['Contactez-nous', '/contact'],
      ],
      stayUpdated: "Restez Informé",
      newsletterText: "Abonnez-vous à notre newsletter pour des mises à jour sur les projets, insights et offres.",
      emailPlaceholder: "Votre email",
      subscribe: "S'abonner",
      contact: {
        phone: "Téléphone:",
        website: "Site web:",
        clients: "Clients:"
      },
      copyright: "© 2025 Etihad Gharbia Contracting Company. Tous droits réservés.",
      terms: "Conditions d'utilisation",
      privacy: "Politique de confidentialité"
    },
    de: {
      companyName: "Etihad Gharbia",
      companyDescription: "Führender Anbieter von Vertrags-, Arbeitskräfte-, Geräteverleih- und Transportlösungen seit 2010.",
      ourServices: "Unsere Dienstleistungen",
      services: [
        ['Vertragsabwicklung', '/services/contracting'],
        ['Gerätevermietung', '/services/equipment-rental'],
        ['Arbeitskräftebereitstellung', '/services/manpower'],
        ['Transport', '/services/transportation'],
        ['IT- und GPS-Lösungen', '/services/it-gps'],
        ['Bauwesen', '/services/construction'],
      ],
      usefulLinks: "Nützliche Links",
      links: [
        ['Über uns', '/about'],
        ['Karriere', '/careers'],
        ['FAQ', '/faq'],
        ['Nachrichten & Medien', '/news'],
        ['Kontakt', '/contact'],
      ],
      stayUpdated: "Bleiben Sie informiert",
      newsletterText: "Abonnieren Sie unseren Newsletter für Updates zu Projekten, Einblicken und Angeboten.",
      emailPlaceholder: "Ihre E-Mail",
      subscribe: "Abonnieren",
      contact: {
        phone: "Telefon:",
        website: "Webseite:",
        clients: "Kunden:"
      },
      copyright: "© 2025 Etihad Gharbia Contracting Company. Alle Rechte vorbehalten.",
      terms: "Nutzungsbedingungen",
      privacy: "Datenschutzrichtlinie"
    }
  };

  // Get translations for current language (default to English if language not found)
  const t = translations[language] || translations.en;

  return (
    <footer className="bg-dark text-white pt-5 pb-3 mt-4">
      <div className="container">
        <div className="row">

          {/* Company Info */}
          <div className="col-md-3 mb-4">
            <div className="mb-3 d-flex align-items-center">
              <img src={Logo} alt="Etihad Gharbia Logo" style={{ width: '80px' }} />
              <span className="ms-2 fw-bold fs-5">{t.companyName}</span>
            </div>
            <p className="small text-light">
              {t.companyDescription}
            </p>

            {/* <div className="d-flex gap-2 mt-3">
              {[FaFacebookF, FaXTwitter, FaYoutube, FaLinkedinIn].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-light btn-sm rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{ width: '35px', height: '35px', transition: 'all 0.3s ease' }}
                  onMouseEnter={e => {
                    e.currentTarget.classList.add("bg-light", "text-dark");
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.classList.remove("bg-light", "text-dark");
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)';
                  }}
                >
                  <Icon />
                </a>
              ))}
            </div> */}


            <div className="d-flex gap-2 mt-3">
              {socialLinks.map(({ icon: Icon, url }, index) => (
                <a
                  key={index}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-light btn-sm rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                  style={{ width: '35px', height: '35px', transition: 'all 0.3s ease' }}
                  onMouseEnter={e => {
                    e.currentTarget.classList.add("bg-light", "text-dark");
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.classList.remove("bg-light", "text-dark");
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)';
                  }}
                >
                  <Icon />
                </a>
              ))}
            </div>




          </div>

          {/* Our Services */}
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold mb-3">{t.ourServices}</h6>
            <ul className="list-unstyled small">
              {t.services.map(([name, link], idx) => (
                <li key={idx}>
                  <a
                    href={link}
                    className="text-white text-decoration-none d-block py-1 hover-underline"
                    onMouseEnter={e => {
                      e.currentTarget.style.color = '#c8102e';
                      e.currentTarget.style.transform = 'translateX(5px)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.color = '#ffffff';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                    style={{ transition: 'all 0.3s ease' }}
                  >
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Useful Links */}
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold mb-3">{t.usefulLinks}</h6>
            <ul className="list-unstyled small">
              {t.links.map(([name, link], idx) => (
                <li key={idx}>
                  <a
                    href={link}
                    className="text-white text-decoration-none d-block py-1 hover-underline"
                    onMouseEnter={e => {
                      e.currentTarget.style.color = '#c8102e';
                      e.currentTarget.style.transform = 'translateX(5px)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.color = '#ffffff';
                      e.currentTarget.style.transform = 'translateX(0)';
                    }}
                    style={{ transition: 'all 0.3s ease' }}
                  >
                    {name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter & Contact */}
          <div className="col-md-5 mb-4">
            <h6 className="fw-bold mb-3">{t.stayUpdated}</h6>
            <p className="small text-light">
              {t.newsletterText}
            </p>
            <form className="d-flex mb-3" onSubmit={e => e.preventDefault()}>
              <input
                type="email"
                placeholder={t.emailPlaceholder}
                className="form-control me-2 rounded-pill shadow-sm"
                style={{ transition: 'all 0.3s ease' }}
                onFocus={e => e.currentTarget.style.boxShadow = '0 0 10px rgba(200, 16, 46, 0.5)'}
                onBlur={e => e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)'}
              />
              <button
                className="btn btn-danger rounded-pill d-flex align-items-center gap-2 px-4 py-2 shadow-sm"
                style={{ transition: 'all 0.3s ease' }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = '#b3001b';
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 6px 15px rgba(200, 16, 46, 0.5)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = '#c8102e';
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.1)';
                }}
              >
                {t.subscribe} <FaArrowRight />
              </button>
            </form>
            <ul className="list-unstyled small text-light mb-2">
              <li><strong>{t.contact.phone}</strong> <a href="tel:+966502114467" className="text-white text-decoration-none">+966 50 211 4467</a></li>
              <li><strong>{t.contact.website}</strong> <a href="https://www.egccsaudi.com" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">www.egccsaudi.com</a></li>
              <li><strong>{t.contact.clients}</strong> Saudi Technic, SAR, MOH, MOI</li>
            </ul>
          </div>

        </div>

        {/* Bottom Footer */}
        <div className="d-flex flex-column flex-md-row justify-content-between border-top border-secondary pt-3 mt-3 small text-muted">
          <div className="mb-2 mb-md-0 text-white">
            {t.copyright}
          </div>
          <div>
            <a
              href="/terms"
              className="text-white me-3 text-decoration-none hover-underline"
              onMouseEnter={e => e.currentTarget.style.color = '#c8102e'}
              onMouseLeave={e => e.currentTarget.style.color = '#ffffff'}
              style={{ transition: 'all 0.3s ease' }}
            >
              {t.terms}
            </a>
            <a
              href="/privacy"
              className="text-white text-decoration-none hover-underline"
              onMouseEnter={e => e.currentTarget.style.color = '#c8102e'}
              onMouseLeave={e => e.currentTarget.style.color = '#ffffff'}
              style={{ transition: 'all 0.3s ease' }}
            >
              {t.privacy}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;






